import { all } from 'redux-saga/effects'

import { employersSaga } from './employers/sagas'
import { candidatesSaga } from './candidates/sagas'
import { mentorsSaga } from './mentors/sagas'

export function* usersSaga() {
  yield all([employersSaga(), candidatesSaga(), mentorsSaga()])
}
